var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14.852 6.376V5.29c0-2.37-1.867-4.29-4.169-4.29H5.168C2.867 1 1 2.92 1 5.29v12.958c0 2.369 1.867 4.29 4.168 4.29h5.526c2.296 0 4.158-1.915 4.158-4.277v-1.098M21 11.77H7.377M17.685 8.375l3.312 3.394-3.312 3.395"
  })));
};
export default SvgLogout;